import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button, CircularProgress, Dialog, DialogActions, DialogContent,
  DialogTitle, makeStyles, TextField,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(() => ({
  btnWrapper: { position: "relative" },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%", left: "50%",
    marginTop: -12, marginLeft: -12,
  },
}));

const ClientModal = ({ open, onClose, clientId }) => {
  const classes = useStyles();
  const [name, setName] = useState("");
  const [sccmCode, setSccmCode] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    if (clientId) {
      api.get("/clients").then(({ data }) => {
        const c = data.find(x => x.id === clientId);
        if (c) { setName(c.name); setSccmCode(c.sccmCode || ""); }
      }).catch(toastError);
    } else {
      setName(""); setSccmCode("");
    }
  }, [open, clientId]);

  const handleClose = () => { onClose(); setName(""); setSccmCode(""); };

  const handleSave = async () => {
    if (!name.trim()) return;
    setLoading(true);
    try {
      if (clientId) {
        await api.put(`/clients/${clientId}`, { name, sccmCode });
        toast.success("Cliente atualizado!");
      } else {
        await api.post("/clients", { name, sccmCode });
        toast.success("Cliente criado!");
      }
      handleClose();
    } catch (err) {
      toastError(err);
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>{clientId ? "Editar Cliente" : "Novo Cliente"}</DialogTitle>
      <DialogContent dividers>
        <TextField
          autoFocus
          label="Nome"
          value={name}
          onChange={e => setName(e.target.value)}
          variant="outlined"
          margin="dense"
          fullWidth
        />
        <TextField
          label="Código SCCM"
          value={sccmCode}
          onChange={e => setSccmCode(e.target.value)}
          variant="outlined"
          margin="dense"
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" disabled={loading}>Cancelar</Button>
        <div className={classes.btnWrapper}>
          <Button onClick={handleSave} color="primary" variant="contained" disabled={loading}>
            Salvar
          </Button>
          {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ClientModal;
